export default __webpack_public_path__ + "static/media/fasting_success_key@2x.77df238c.jpg";